import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import { Skeleton } from "@material-ui/lab";
import { Avatar, Button, Divider, Grid, Typography } from "@material-ui/core";

// import { AuthContext } from "../../context/Auth/AuthContext";

import NewTicketModalPageContact from "../../components/NewTicketModalPageContact";

const VcardPreview = ({ contact, numbers }) => {
  const history = useHistory();
  // const { user } = useContext(AuthContext);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [, setContactTicket] = useState({});
  const [selectedContact, setContact] = useState({
    name: "",
    number: 0,
    profilePicUrl: "",
  });

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          let contactObj = {
            name: contact,
            number: numbers.replace(/\D/g, ""),
            email: "",
          };
          const { data } = await api.post("/contact", contactObj);
          setContact(data);
        } catch (err) {
          console.log(err);
          toast.error(err.response.data.error);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [contact, numbers]);

  // const handleNewChat = async () => {
  //     try {
  //         const { data: ticket } = await api.post("/tickets", {
  //             contactId: selectedContact.id,
  //             userId: user.id,
  //             status: "open",
  //         });
  //         history.push(`/tickets/${ticket.id}`);
  //     } catch (err) {
  //         toast.error(err.response.data.error);
  //     }
  // }

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.id !== undefined) {
      history.push(`/tickets/${ticket.id}`);
    }
  };

  return (
    <>
      <div
        style={{
          minWidth: "250px",
        }}
      >
        <Grid container spacing={1}>
          <NewTicketModalPageContact
            modalOpen={newTicketModalOpen}
            initialContact={selectedContact}
            onClose={(ticket) => {
              handleCloseOrOpenTicket(ticket);
            }}
          />
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {selectedContact.name ? (
              <Avatar src={selectedContact.profilePicUrl} />
            ) : (
              <Skeleton variant="circular" width={40} height={40} />
            )}
          </Grid>
          <Grid item xs={9}>
            {selectedContact.name ? (
              <Typography
                style={{ marginTop: "12px", marginLeft: "10px" }}
                variant="subtitle1"
                color="primary"
                gutterBottom
              >
                {selectedContact.name}
                <br />
                {selectedContact.number}
              </Typography>
            ) : (
              <>
                <Skeleton
                  variant="text"
                  width={140}
                  style={{ marginTop: 12, marginLeft: 10 }}
                />
                <Skeleton
                  variant="text"
                  width={100}
                  style={{ marginLeft: 10 }}
                />
              </>
            )}
          </Grid>
          <Grid item xs={12}>
            <Divider />
            {/* {contacts.map((contact) => (
                            <IconButton
                                key={contact.id}
                                size="small"
                                onClick={() => {
                                    setContactTicket(contact);
                                    setNewTicketModalOpen(true);
                                }}
                            >
                                <WhatsApp color="secondary" />
                            </IconButton>
                        ))} */}
            <Button
              fullWidth
              color="primary"
              key={selectedContact.id}
              // onClick={handleNewChat}
              onClick={() => {
                setContactTicket(selectedContact.id);
                setNewTicketModalOpen(true);
              }}
              disabled={!selectedContact.number}
            >
              Conversar
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default VcardPreview;
